import "@/user/common";
import React from "react";
import { createRoot } from "react-dom/client";
import Concept from "@/shared/components/concept/";
import { getConceptTop, getConceptStaff, getConceptPortfolio } from "./api";

// ReactのConceptを呼び出す
const concept = document.getElementById("concept");
const hallId = parseInt(concept.dataset.hall_id, 10);

if (concept) {
  const root = createRoot(concept);
  root.render(
    <Concept
      hallId={hallId}
      getConceptTop={getConceptTop}
      getConceptStaff={getConceptStaff}
      getConceptPortfolio={getConceptPortfolio}
    />,
  );
}
